import 'ui-ng-delegate';
require('ui-ng-notification');
require('ui-ng-modal');

import './core';
require('./components/session_timer/session_timer.es');
require('./components/user_session_timeout_modal/user_session_timeout.es');
require('./commands/extend_session_command.es');
require('./config_files/session_timeout_interceptors.es');

// module.exports = 'ui-ng-session-timer';



// WEBPACK FOOTER //
// ./app/vendor/ui-ng-session-timer/src/main.js